import React from 'react';
import { useTranslation } from 'react-i18next';

export const TechInfo = () => {
  const { t } = useTranslation();

  return (
    <>
      {t('epdWizard.wizardStep2.info.technology.tech1')}
      <br />
      <br />
      {t('epdWizard.wizardStep2.info.technology.tech2')}
      <br />
      <br />- {t('epdWizard.wizardStep2.info.technology.tech3')}
      <br />- {t('epdWizard.wizardStep2.info.technology.tech4')}
      <br />- {t('epdWizard.wizardStep2.info.technology.tech5')}
      <br />- {t('epdWizard.wizardStep2.info.technology.tech6')}
      <br />
      <br />
      {t('epdWizard.wizardStep2.info.technology.tech7')}
    </>
  );
};
